<div class="tw-message-add-form">
    <div class="content clearfix">
        <div class="element text-area">
            <core-helpers-forms-wysiwyg-extended
                [placeholder]="placeholder"
                [content]="messageContent"
                (textChange)="onMessageChange($event)"
            ></core-helpers-forms-wysiwyg-extended>
        </div>
        <div class="element text-upload">
                <core-storage-files-upload 
                    [contextUrl]="storageFilesUrlPrefix" 
                    [context]="context" 
                    (response)='upload($event)'
                    (onUploading)="uploading = $event">
                </core-storage-files-upload>
        </div>
    </div>
    <div class="box_fieldset">
      <core-helpers-forms-button-white [disabled]="buttonDisabled || uploading" [text]="'SAVE MESSAGE'" (click)= "sendMessage($event)"></core-helpers-forms-button-white>
      <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="cancel()"></core-helpers-forms-button>
    </div>
</div>
